<!--
 * @Author: guoyu
 * @Date: 2020-09-10 20:45:12
 * @LastEditors: zheng zheng@sense.sg
 * @LastEditTime: 2024-12-04 15:45:02
 * @Description: 技能基礎信息與下單
-->
<template>
  <div class="skill-base-info" :class="{ 'is-fixed-top': isFixedTop && isPC }">
    <div class="mode-list">
      <div
        v-for="(p, i) in skillPriceList"
        :key="'price' + (i + 1)"
        class="model-price"
        :class="{
          //'seven-min-mode':p.salesUnit=='Minutes7',
          selected: selectedModelId === p.id
        }"
        @click="selectPrice(p)"
      >
        <span class="model-name">{{ p.name }}</span>
        <!-- <span v-if="p.salesUnit=='Minutes7'"><fps-icon type="arrow-right" size="10" /></span> -->
        <span class="price"
          >{{ p.price }}{{$t('upgrade_page_views_home_suggest_item_4')}}/{{ p.salesUnit | salesUnitTranslate }}</span
        >
      </div>
    </div>
    <div class="display-price">
      <div class="price skill-price">
        <span class="sale-price">{{ selectedModel.showPrice }}</span>
        <span class="sale-price">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
        <span class="sale-unit"
          >/{{ selectedModel.salesUnit | salesUnitTranslate }}</span
        >
        <span
          v-if="selectedModel.showPrice !== selectedModel.price"
          class="old-price"
          >{{ selectedModel.price }}{{$t('upgrade_page_views_home_suggest_item_4')}}/{{
            selectedModel.salesUnit | salesUnitTranslate
          }}</span
        >
      </div>
      <div class="coupon-tags">
        <div
          v-if="skillInfo.redBagFreeFlag && selectedModel.showPrice === 1"
          class="price-onecoin"
        >
          <span class="coin-tag">{{$t('upgrade_page_views_player_list_player_item_173')}}</span>{{$t('upgrade_page_views_master_components_skill_info_base_info_254')}}</div>
        <div v-else-if="discountList.length" class="discount-list">
          <div
            v-for="(d, i) in discountList"
            :key="`discount-${i}`"
            class="one-discount"
          >
            {{ d }}
          </div>
        </div>
        <div
          v-if="
            skillInfo.giveAwayList &&
              skillInfo.giveAwayList.length &&
              !newerCoupon
          "
        >
          <div
            v-for="(g, i) in skillInfo.giveAwayList"
            :key="`give-away${i}`"
            class="one-give-away"
          >
            {{$t('upgrade_page_views_master_components_skill_info_base_info_255',[g.startNum,g.giftNum])}}
          </div>
        </div>
      </div>
    </div>
    <div class="row-info">
      <span class="row-name">{{$t('upgrade_page_views_master_components_skill_info_base_info_256')}}</span
      ><span>{{ skillInfo.countTransactions }}</span>
    </div>
    <div class="row-info">
      <span class="row-name">{{$t('upgrade_page_views_master_components_skill_info_base_info_257')}}</span
      ><span
        >{{$t('upgrade_page_views_master_components_skill_info_base_info_258', [ skillInfo.starRating , skillInfo.countComment ])}}<i
          class="el-icon-arrow-right go-comment"
          v-if="skillInfo.countComment"
          @click="lookComment"
        ></i
      ></span>
    </div>
    <div v-if="labelList.length" class="skill-description-tags">
      <div class="tags-list">
        <div
          class="label-tag"
          v-for="(l, i) in labelList"
          :key="'label-' + (l.labelId || i)"
          :class="l.classes"
        >
          {{ l.onlyShowIamge ? '' : l.name }}
        </div>
      </div>
      <el-popover
        placement="top-end"
        popper-class="tip-popper-container"
        trigger="hover"
        :width="280"
      >
        <div class="label-text">
          <div class="tip-title">{{$t('upgrade_page_views_master_components_skill_info_base_info_259')}}</div>
          <ul>
            <li class="tip-line">
              <span class="custom-tag rebought tag-wrap">{{$t('upgrade_page_views_player_list_index_195')}}</span>
              <span>{{$t('upgrade_page_views_master_components_skill_info_base_info_260')}}</span>
            </li>
            <li class="tip-line">
              <span class="custom-tag nice tag-wrap">{{$t('upgrade_page_views_player_list_index_198')}}</span>
              <span>{{$t('upgrade_page_views_master_components_skill_info_base_info_261')}}</span>
            </li>
            <li class="tip-line">
              <span class="custom-tag hot tag-wrap">{{$t('upgrade_page_views_player_list_index_199')}}</span>
              <span>{{$t('upgrade_page_views_master_components_skill_info_base_info_262')}}</span>
            </li>
            <li
              v-if="labelList && labelList.some(v => v.name == $t('upgrade_page_views_player_list_index_200'))"
              class="tip-line"
            >
              <span class="custom-tag new tag-wrap">{{$t('upgrade_page_views_player_list_index_200')}}</span>
              <span>{{$t('upgrade_page_views_master_components_skill_info_base_info_263')}}</span>
            </li>
            <li class="tip-line" v-if="showLolTag">
              <span class="comment-tag top tag-wrap">{{$t('upgrade_page_views_master_components_skill_info_base_info_264')}}</span>
              <span>{{$t('upgrade_page_views_master_components_skill_info_base_info_265')}}</span>
            </li>
          </ul>
        </div>
        <fps-icon
          slot="reference"
          class="reverse-y"
          type="warning-inline"
          size="18"
          color="#636D86"
        />
      </el-popover>
    </div>
    <div
      class="senven-min-banner"
      v-if="min7Mode"
      @click="selectPrice(min7Mode)"
    >
      <div class="v2147_411"></div>
      <div class="v2147_412"></div>
      <span class="v2147_413">{{$t('upgrade_page_views_master_components_skill_info_base_info_266')}}</span
      ><span class="v2147_414">{{ min7Mode.price }}幣></span>
      <div class="name"></div>
    </div>
    <div class="footer-buttons" v-if="!isSelf">
      <FPSButton class="chat-button" @click="goChat">
        <fps-icon class="chat-icon" type="message"></fps-icon>{{$t('upgrade_page_views_master_components_skill_info_base_info_267')}}</FPSButton
      >
      <FPSButton class="order-button" @click="placeOrder">{{$t('upgrade_page_views_master_components_skill_info_base_info_268')}}
        <!-- <div class="rebate-tag">返現</div> --></FPSButton>
    </div>
    <div class="order-bottom" v-show="isShowbottom && !isSelf">
      <div class="price-wrap price">
        <span class="sale-price">{{ selectedModel.showPrice }}</span>
        <span class="sale-price">{{$t('upgrade_page_views_home_suggest_item_4')}}</span>
        <span class="sale-unit"
          >/{{ selectedModel.salesUnit | salesUnitTranslate }}</span
        >
        <span
          v-if="selectedModel.showPrice !== selectedModel.price"
          class="old-price"
          >{{ selectedModel.price }}{{$t('upgrade_page_views_home_suggest_item_4')}}/{{
            selectedModel.salesUnit | salesUnitTranslate
          }}</span
        >
      </div>
      <div class="button-group">
        <FPSButton class="chat-button" @click="goChat">
          <fps-icon class="chat-icon" type="message"></fps-icon
          >{{$t('upgrade_page_views_master_components_skill_info_base_info_267')}}</FPSButton
        >
        <FPSButton class="order-button" @click="placeOrder">{{$t('upgrade_page_views_master_components_skill_info_base_info_268')}}
          <!-- <div class="rebate-tag">返現</div> --></FPSButton>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from '@/locales/index'

import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';
import FPSButton from '@/components/common/button/normal';
let scrollFn;
export default {
  name: 'BaseInfo',
  components: {
    FPSButton
  },
  props: {
    skillInfo: {
      type: Object,
      default: nullObj
    },
    isSelf: {
      type: Boolean,
      default: false
    },
    min7Mode: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      chatTipsShow: !(window.localStorage.getItem('HAS_TIP_SHOW') * 1),
      isFixedTop: false,
      selectedModelId: 0,
      isShowbottom: false
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'newerCoupon']),
    skillPriceList() {
      let defaultMode = [this.defaultPriceModel];
      if (
        this.skillInfo.skillPriceList &&
        this.skillInfo.skillPriceList.length
      ) {
        let priceList = this.skillInfo.skillPriceList.map(item => {
          return {
            ...item,
            showPrice: Math.max(item.showPrice - this.firstCoupon, 0)
          };
        });
        let result = defaultMode.concat(priceList);
        // 7min模式放最前面
        if (this.skillInfo.gameId == 36 && this.min7Mode) {
          return result.sort((x, y) =>
            x.salesUnit == 'Minutes7' ? -1 : y.salesUnit == 'Minutes7' ? 1 : 0
          );
        }
        return result;
      }
      return defaultMode;
    },
    firstCoupon() {
      if (this.skillInfo.firstOrderPrivilege) {
        return this.skillInfo.firstOrderDiscount || 0;
      }
      return 0;
    },
    defaultPriceModel() {
      return {
        id: 0,
        name: i18n.t('upgrade_page_views_master_components_skill_info_base_info_269'),
        price: this.skillInfo.price,
        showPrice:
          this.$util.computedPrice(this.skillInfo) !== ''
            ? this.$util.computedPrice(this.skillInfo)
            : this.skillInfo.salesPrice,
        salesUnit: this.skillInfo.salesUnit
      };
    },
    discountList() {
      const list = [];
      if (!this.userInfo) {
        this.newDiscountList(list);
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_270', [this.$util.newerDiscount]));
      } else if (this.newerCoupon) {
        this.newDiscountList(list);
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_270', [this.newerCoupon.couponAmount]));
      } else if (this.skillInfo.firstOrderPrivilege) {
        list.push(i18n.t('upgrade_page_views_player_list_index_196'));
      }
      return list;
    },
    labelList() {
      // const labelList = [
      //   {
      //     gameId: 38,
      //     labelId: 15,
      //     labelType: 'Default',
      //     showType: 'Default',
      //     labelName: 'PlayerHot'
      //   },
      //   {
      //     gameId: 38,
      //     labelData: '0.58',
      //     labelId: 10,
      //     labelType: 'Default',
      //     showType: 'Default',
      //     labelName: 'Repurchase'
      //   }
      // ];
      return this.$util
        .computedTags(this.skillInfo.labelList || [])
        .concat(
          this.$util
            .computedTags(this.skillInfo.labelList || [], 'comment')
            .slice(0, 2)
        )
        .filter(v => v.id != 16);
    },
    showLolTag() {
      if (!this.skillInfo.labelList) return false;
      return this.skillInfo.labelList.some(
        item => item.labelId > 1000 && item.labelId < 10000
      );
    },
    selectedModel() {
      return (
        this.skillPriceList.find(item => {
          return this.selectedModelId === item.id;
        }) || {}
      );
    }
  },
  methods: {
    lookComment() {
      const mainDom = document.getElementById('page-main');
      mainDom.scrollTop = 600;
    },
    selectPrice(model) {
      if (this.skillInfo.gameId != 36 && model.salesUnit == 'Minutes7') {
        this.$emit('switchToVoice');
        return;
      }
      this.selectedModelId = model.id;
    },
    newDiscountList(list) {
      if (
        this.selectedModel.id === 0 &&
        this.skillInfo.redBagFreeFlag &&
        this.skillInfo.selfSpreadDiscount
      ) {
        list.push(i18n.t('upgrade_page_views_master_components_skill_info_base_info_271', [this.skillInfo.selfSpreadDiscount * 10]));
      }
    },
    async placeOrder() {
      this.$adjust('web_request_btn_click', {
        price: this.skillInfo.salesPrice,
        skill: this.skillInfo.id
      });
      if (!this.userInfo) {
        Login();
        return;
      }
      let date = new Date().getTime();
      this.$util.openWindow(
        `/order/check/${this.skillInfo.id}/1?date=${date}&price=${this
          .selectedModel.id || ''}`
      );
    },
    goChat() {
      this.$adjust('web_chat_btn_click', {
        user_id: this.$route.params.uuid
      });
      let playerUuid = this.$route.params.uuid;
      if (!this.userInfo) {
        Login();
        return;
      } else {
        this.$util.openChatWindow(
          this.userInfo.uuid,
          playerUuid,
          this.skillInfo.id
        );
      }
    }
  },
  mounted() {
    let scrollDom = document.getElementsByTagName('main')[0];
    scrollFn = this.$util.throttle(() => {
      if (scrollDom.scrollTop < 350) {
        this.isShowbottom = false;
      } else {
        this.isShowbottom = true;
      }
    }, 10);
    scrollDom.addEventListener('scroll', scrollFn);
  },
  destroyed() {
    let scrollDom = document.getElementsByTagName('main')[0];
    scrollDom.removeEventListener('scroll', scrollFn);
  }
};
function nullObj() {
  return {};
}
</script>
<style lang="scss" scoped>
.skill-base-info {
  padding: 0 16px;
}
.mode-list {
  display: flex;
  flex-wrap: wrap;
  margin: 16px 0 8px;
}
.model-price {
  padding: 0 8px;
  height: 28px;
  border: 1px solid #e8eaee;
  border-radius: 4px;
  font-size: 12px;
  color: $color-gray-2;
  cursor: pointer;
  @include flex;
  margin: 8px 8px 0 0;
  &.selected {
    background: #fffbf9;
    border: 1px solid #e49f78;
    font-weight: 500;
    color: $color-gray-1;
  }
  &.seven-min-mode {
    background: #34c022;
    color: #fff;
  }
}
.model-name {
  margin-right: 8px;
}
.display-price {
  .price-onecoin {
    display: inline-block;
    position: relative;
    overflow: hidden;
    height: 18px;
    padding-right: 8px;
    border: 1px solid $color-orange;
    margin-top: 6px;
    line-height: 18px;
    color: $color-orange;
    border-radius: 2px;
    font-size: 12px;
  }
  .coin-tag {
    width: 50px;
    padding: 0 8px;
    margin-right: 4px;
    background: $color-orange;
    color: #fff;
    font-weight: 800;
  }
  .discount-list {
    @include flex(flex-start);
    margin: 8px 8px 0 0;
    height: 24px;
  }
  .one-discount {
    padding: 4px 8px;
    height: 100%;
    @include flex;
    font-size: 13px;
    line-height: 16px;
    color: #ff6610;
    background: rgba(254, 127, 56, 0.15);
    border-radius: 34px;
  }
}
.price {
  @include flex(flex-start, flex-end);
  line-height: 24px;
  font-size: 12px;
  font-weight: 500;
}
.skill-price {
  color: #fe7f38;
}
.sale-price {
  font-weight: 600;
  font-size: 24px;
  line-height: 34px;
  margin-right: 2px;
}
.sale-unit {
  margin-left: 2px;
}
.old-price {
  margin-left: 8px;
  text-decoration-line: line-through;
  color: $color-gray-3;
}
.coupon-tags {
  display: flex;
  justify-content: flex-start;
}
.one-give-away {
  display: inline-block;
  height: 24px;
  padding: 0 4px;
  border: 1px solid #ffeae6;
  margin: 8px 6px 0 0;
  line-height: 23px;
  border-radius: 4px;
  color: #ea320a;
  font-size: 13px;
}
.row-info {
  margin-top: 8px;
  font-size: 15px;
  line-height: 24px;
}
.row-name {
  margin-right: 12px;
  color: #636d86;
}
.go-comment {
  cursor: pointer;
}
.skill-description-tags {
  margin-top: 8px;
  @include flex(space-between);
}
.tip-line {
  display: flex;
  margin-bottom: 8px;
}
.tag-wrap {
  margin-right: 8px;
}
.label-text {
  padding: 12px;
}
.tip-title {
  margin-bottom: 16px;
}
.tags-list {
  @include flex(flex-start);
}
.label-tag {
  height: 24px !important;
  margin-right: 8px;
  &::before {
    width: 20px;
    height: 20px;
  }
}
.chat-button {
  margin-right: 16px;
}
.chat-button,
.order-button {
  min-width: 140px;
  /deep/ .button-box {
    position: relative;
    height: 52px;
    font-size: 17px;
  }
}
.rebate-tag {
  position: absolute;
  right: 0px;
  top: -4px;
  height: 18px;
  padding: 3px 8px;
  background: #ea722f;
  border-radius: 100px;
  font-weight: 400;
  font-size: 12px;
  line-height: 12px;
  color: #ffe87b;
}
.chat-icon {
  margin-right: 8px;
}
.footer-buttons {
  margin: 16px 0 24px;
}
.order-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding-left: calc(50% - 440px);
  padding-right: calc(50% - 600px);
  transition: all 0.3s ease-in-out;
  z-index: 20;
  height: 91px;
  border-top: 1px solid $color-split;
  background: #fff;
  @include flex(space-between);
  .price-wrap {
    color: $color-price;
    @include flex(flex-start, flex-end);
  }
}

@media screen and (max-width: 599px) {
  .button-group,
  .footer-buttons {
    display: flex;
    align-items: center;
  }
  .chat-button,
  .order-button {
    min-width: 80px;
    /deep/ .button-box {
      font-size: 12px !important;
      height: 32px;
      padding: 0 10px;
    }
  }
  .chat-button {
    margin-right: 4px;
  }
  .order-bottom {
    padding: 0 12px;
  }
}
</style>
<style lang="scss" scoped>
.senven-min-banner {
  cursor: pointer;
  width: 343px;
  height: 38px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  position: relative;
  margin-top: 16px;
  margin-bottom: 32px;
  .v2147_411 {
    width: 343px;
    height: 38px;
    background: rgba(251, 239, 234, 1);
    opacity: 1;
    position: absolute;
    top: 0px;
    left: 0px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    overflow: hidden;
  }
  .v2147_412 {
    width: 89px;
    height: 38px;
    background: rgba(216, 159, 135, 1);
    opacity: 1;
    position: absolute;
    top: 0px;
    left: 254px;
  }
  .v2147_413 {
    color: rgba(176, 94, 54, 1);
    position: absolute;
    top: 12px;
    left: 12px;
    font-size: 13px;
    opacity: 1;
    text-align: left;
  }
  .v2147_414 {
    color: rgba(255, 255, 255, 1);
    position: absolute;
    top: 12px;
    left: 284px;
    font-size: 14px;
    opacity: 1;
    text-align: right;
    font-weight: 500;
  }
  .name {
    color: #fff;
  }
}
</style>
